import { memo, useState } from "react";
import { IconPlayerSkipBackFilled, IconPlayerSkipForwardFilled } from "@tabler/icons-react";

import { Text } from "@fragments";
import { UserAvatar } from "@components/Community";
import videoHelpers from "@helpers/video.js";

/**
 * PlaylistNavButton — previous/next control. When a neighbor exists, hovering
 * lifts a small preview card (thumbnail + title + creator) above the button;
 * without one the button renders disabled. The thumbnail fallback is only
 * generated on first hover, so idle playback costs nothing.
 */
function PlaylistNavButton({ direction, content, onNavigate }) {
    const isNext = direction === "next";
    const [thumb, setThumb] = useState(content?.banner || null);
    const [thumbRequested, setThumbRequested] = useState(false);

    const Icon = isNext ? IconPlayerSkipForwardFilled : IconPlayerSkipBackFilled;
    const label = isNext ? "Próximo vídeo" : "Vídeo anterior";

    async function handleFirstHover() {
        if (thumb || thumbRequested || !content?.video?.src) return;
        setThumbRequested(true);
        try {
            setThumb(await videoHelpers.generateThumbFromVideo(content.video.src));
        } catch {
            // no thumbnail — the preview card still shows title + creator
        }
    }

    return (
        <div
            className="player-nav"
            onMouseEnter={content ? handleFirstHover : undefined}
            onClick={(event) => event.stopPropagation()}
        >
            <button
                type="button"
                aria-label={label}
                disabled={!content}
                className="player-control-button"
                onClick={() => content && onNavigate(content)}
            >
                <Icon />
            </button>

            {content && (
                <div className="player-nav__preview" onClick={() => onNavigate(content)}>
                    <div className="player-nav__preview-thumb">
                        {thumb && <img src={thumb} alt={content?.name} />}
                    </div>
                    <div className="player-nav__preview-info">
                        <Text.subheading contrast={6}>{isNext ? "A seguir" : "Anterior"}</Text.subheading>
                        <Text.label contrast={9} maxLines={2}>{content?.name}</Text.label>
                        {content?.creator && (
                            <UserAvatar user={content.creator} size={18} displayName={true} />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default memo(PlaylistNavButton);
